import axios from 'axios'

export const getUsers = (partnerId: string) => {
  return axios
    .get('/data/sadarbības_partnera_personas?sadarbības_partneris_id=' + partnerId)
    .then((resp) => resp.data)
}
